import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { deleteEmailPrompt, saveEmailPrompt, updateEmailPrompt } from "@Broker/@Modules/clients/applications/application/api/application-api";
export default defineComponent({
  name: "AiEmailTemplateModal",
  components: {
    GenericModal,
    SimpleButton,
    InlinePrompt
  },
  props: {
    type: {
      type: String,
      required: true
    },
    customPrompt: {
      type: String,
      required: true,
      default: ""
    },
    savedPrompts: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props, {
    emit
  }) {
    const aiEmailTemplateModal = ref();
    const replaceInstructionsModal = ref();
    const currentType = ref(props.type);
    const templateTitle = ref("");
    const templateInstructions = ref(props.customPrompt || "");
    const selectedTemplate = ref(null);
    const editingTemplate = ref(null);
    const localSavedTemplates = ref([]);
    const initialTemplateTitle = ref("");
    const initialTemplateInstructions = ref("");
    const savingTemplate = ref(false);
    const deletingTemplateId = ref(null);
    const isInlineEditing = ref(false);
    const hasTemplateChanges = computed(() => {
      var _context, _context2, _context3, _context4;
      return _trimInstanceProperty(_context = templateTitle.value).call(_context) !== _trimInstanceProperty(_context2 = initialTemplateTitle.value).call(_context2) || _trimInstanceProperty(_context3 = templateInstructions.value).call(_context3) !== _trimInstanceProperty(_context4 = initialTemplateInstructions.value).call(_context4);
    });
    const primaryButtonText = computed(() => {
      if (currentType.value === "load" && isInlineEditing.value) {
        return "global.words.save";
      }
      if (currentType.value === "load") {
        return "email.custom.loadTemplateAction";
      }
      return "global.words.save";
    });
    const secondaryButtonText = computed(() => {
      if (currentType.value === "load" && isInlineEditing.value) {
        return "global.words.cancel";
      }
      return currentType.value === "load" ? "global.words.close" : "global.words.cancel";
    });
    const primaryButtonDisabled = computed(() => {
      var _context5, _context6;
      if (savingTemplate.value) {
        return true;
      }
      if (currentType.value === "load" && !isInlineEditing.value) {
        return !selectedTemplate.value;
      }
      if (!_trimInstanceProperty(_context5 = templateTitle.value).call(_context5) || !_trimInstanceProperty(_context6 = templateInstructions.value).call(_context6)) {
        return true;
      }
      if (currentType.value === "edit" || currentType.value === "load" && isInlineEditing.value) {
        return !hasTemplateChanges.value;
      }
      return false;
    });
    const openModal = (type = props.type) => {
      var _aiEmailTemplateModal;
      currentType.value = type;
      isInlineEditing.value = false;
      editingTemplate.value = null;
      templateTitle.value = "";
      templateInstructions.value = type === "save" || type === "edit" ? props.customPrompt || "" : "";
      initialTemplateTitle.value = "";
      initialTemplateInstructions.value = templateInstructions.value;
      localSavedTemplates.value = [...props.savedPrompts];
      selectedTemplate.value = type === "load" && localSavedTemplates.value.length ? localSavedTemplates.value[0] : null;
      (_aiEmailTemplateModal = aiEmailTemplateModal.value) == null ? void 0 : _aiEmailTemplateModal.show();
    };
    const closeModal = () => {
      var _aiEmailTemplateModal2;
      (_aiEmailTemplateModal2 = aiEmailTemplateModal.value) == null ? void 0 : _aiEmailTemplateModal2.hide();
    };
    const resetEditState = () => {
      isInlineEditing.value = false;
      editingTemplate.value = null;
      templateTitle.value = "";
      templateInstructions.value = props.customPrompt || "";
      initialTemplateTitle.value = "";
      initialTemplateInstructions.value = "";
    };
    const handleHidden = () => {
      var _replaceInstructionsM;
      emit("close-modal");
      currentType.value = props.type;
      selectedTemplate.value = null;
      resetEditState();
      (_replaceInstructionsM = replaceInstructionsModal.value) == null ? void 0 : _replaceInstructionsM.hide();
    };
    const isSelectedTemplate = template => {
      if (!selectedTemplate.value) {
        return false;
      }
      if (selectedTemplate.value.id && template.id) {
        return selectedTemplate.value.id === template.id;
      }
      return selectedTemplate.value.title === template.title;
    };
    const selectTemplate = template => {
      if (isInlineEditing.value) {
        return;
      }
      selectedTemplate.value = template;
    };
    const openEditTemplate = template => {
      if (!template.id) {
        return;
      }
      selectedTemplate.value = template;
      editingTemplate.value = template;
      templateTitle.value = template.title;
      templateInstructions.value = template.prompt;
      initialTemplateTitle.value = template.title;
      initialTemplateInstructions.value = template.prompt;
      isInlineEditing.value = true;
    };
    const cancelInlineEdit = () => {
      if (editingTemplate.value) {
        selectedTemplate.value = editingTemplate.value;
      }
      resetEditState();
    };
    const handleSaveTemplate = async () => {
      var _context7, _context8;
      if (savingTemplate.value || !_trimInstanceProperty(_context7 = templateTitle.value).call(_context7) || !_trimInstanceProperty(_context8 = templateInstructions.value).call(_context8)) {
        return;
      }
      savingTemplate.value = true;
      try {
        var _editingTemplate$valu;
        if (currentType.value === "edit" && (_editingTemplate$valu = editingTemplate.value) != null && _editingTemplate$valu.id) {
          await updateEmailPrompt(editingTemplate.value.id, templateTitle.value, templateInstructions.value);
          emit("template-updated");
          closeModal();
          return;
        }
        await saveEmailPrompt(templateTitle.value, templateInstructions.value);
        emit("template-created");
        closeModal();
      } finally {
        savingTemplate.value = false;
      }
    };
    const handleUpdateSelectedTemplate = async () => {
      var _editingTemplate$valu2, _context9, _context0, _context1;
      if (savingTemplate.value || !((_editingTemplate$valu2 = editingTemplate.value) != null && _editingTemplate$valu2.id) || !_trimInstanceProperty(_context9 = templateTitle.value).call(_context9) || !_trimInstanceProperty(_context0 = templateInstructions.value).call(_context0) || !hasTemplateChanges.value) {
        return;
      }
      const previousTemplates = [...localSavedTemplates.value];
      const previousSelectedTemplate = selectedTemplate.value;
      const updatedTemplate = _objectSpread(_objectSpread({}, editingTemplate.value), {}, {
        title: templateTitle.value,
        prompt: templateInstructions.value
      });
      localSavedTemplates.value = _mapInstanceProperty(_context1 = localSavedTemplates.value).call(_context1, template => template.id === updatedTemplate.id ? updatedTemplate : template);
      selectedTemplate.value = updatedTemplate;
      resetEditState();
      savingTemplate.value = true;
      try {
        await updateEmailPrompt(updatedTemplate.id, updatedTemplate.title, updatedTemplate.prompt);
        emit("template-updated", updatedTemplate);
      } catch (error) {
        localSavedTemplates.value = previousTemplates;
        selectedTemplate.value = previousSelectedTemplate;
      } finally {
        savingTemplate.value = false;
      }
    };
    const handleDeleteTemplate = async template => {
      var _context10, _selectedTemplate$val;
      if (!template.id || deletingTemplateId.value) {
        return;
      }
      const previousTemplates = [...localSavedTemplates.value];
      const previousSelectedTemplate = selectedTemplate.value;
      localSavedTemplates.value = _filterInstanceProperty(_context10 = localSavedTemplates.value).call(_context10, savedTemplate => savedTemplate.id !== template.id);
      if (((_selectedTemplate$val = selectedTemplate.value) == null ? void 0 : _selectedTemplate$val.id) === template.id) {
        selectedTemplate.value = localSavedTemplates.value[0] || null;
      }
      deletingTemplateId.value = template.id;
      try {
        await deleteEmailPrompt(template.id);
        emit("template-deleted", template.id);
      } catch (error) {
        localSavedTemplates.value = previousTemplates;
        selectedTemplate.value = previousSelectedTemplate;
      } finally {
        deletingTemplateId.value = null;
      }
    };
    const loadSelectedTemplate = () => {
      var _replaceInstructionsM2;
      if (!selectedTemplate.value) {
        return;
      }
      emit("load-prompt", selectedTemplate.value.prompt);
      (_replaceInstructionsM2 = replaceInstructionsModal.value) == null ? void 0 : _replaceInstructionsM2.hide();
      closeModal();
    };
    const handleLoadTemplate = () => {
      var _context11, _context12, _context13;
      if (!selectedTemplate.value) {
        return;
      }
      const hasExistingInstructions = !!_trimInstanceProperty(_context11 = props.customPrompt).call(_context11);
      const isSameTemplateContent = _trimInstanceProperty(_context12 = props.customPrompt).call(_context12) === _trimInstanceProperty(_context13 = selectedTemplate.value.prompt).call(_context13);
      if (hasExistingInstructions && !isSameTemplateContent) {
        var _replaceInstructionsM3;
        (_replaceInstructionsM3 = replaceInstructionsModal.value) == null ? void 0 : _replaceInstructionsM3.show();
        return;
      }
      loadSelectedTemplate();
    };
    const confirmReplaceInstructions = () => {
      loadSelectedTemplate();
    };
    const cancelReplaceInstructions = () => {
      var _replaceInstructionsM4;
      (_replaceInstructionsM4 = replaceInstructionsModal.value) == null ? void 0 : _replaceInstructionsM4.hide();
    };
    const copyInstructionsToClipboard = async instructions => {
      if (!instructions || !navigator.clipboard) {
        return;
      }
      await navigator.clipboard.writeText(instructions);
    };
    const handlePrimaryAction = () => {
      if (currentType.value === "load" && isInlineEditing.value) {
        handleUpdateSelectedTemplate();
        return;
      }
      if (currentType.value === "load") {
        handleLoadTemplate();
        return;
      }
      handleSaveTemplate();
    };
    const handleSecondaryAction = () => {
      if (currentType.value === "load" && isInlineEditing.value) {
        cancelInlineEdit();
        return;
      }
      closeModal();
    };
    watch(() => props.savedPrompts, savedTemplates => {
      var _context14;
      if (savingTemplate.value || deletingTemplateId.value) {
        return;
      }
      localSavedTemplates.value = [...savedTemplates];
      if (currentType.value !== "load" || isInlineEditing.value) {
        return;
      }
      if (!selectedTemplate.value && localSavedTemplates.value.length) {
        selectedTemplate.value = localSavedTemplates.value[0];
        return;
      }
      const refreshedTemplate = _findInstanceProperty(_context14 = localSavedTemplates.value).call(_context14, template => {
        var _selectedTemplate$val2;
        return template.id === ((_selectedTemplate$val2 = selectedTemplate.value) == null ? void 0 : _selectedTemplate$val2.id);
      });
      if (refreshedTemplate) {
        selectedTemplate.value = refreshedTemplate;
      }
    });
    return {
      aiEmailTemplateModal,
      replaceInstructionsModal,
      currentType,
      templateTitle,
      templateInstructions,
      selectedTemplate,
      localSavedTemplates,
      savingTemplate,
      deletingTemplateId,
      isInlineEditing,
      primaryButtonText,
      secondaryButtonText,
      primaryButtonDisabled,
      openModal,
      closeModal,
      handleHidden,
      isSelectedTemplate,
      selectTemplate,
      openEditTemplate,
      copyInstructionsToClipboard,
      handleDeleteTemplate,
      handlePrimaryAction,
      handleSecondaryAction,
      confirmReplaceInstructions,
      cancelReplaceInstructions
    };
  }
});